interface CreditFooterProps {
  text: string;
}

/**
 * Dauerhaft sichtbarer Credit-Hinweis (aus APP_CREDIT_NAME).
 * Sitzt unten **links**, damit er sich nicht mit dem Toast-Stack (unten rechts)
 * oder der Editor-Minimap (unten rechts im Canvas) überlagert.
 */
export function CreditFooter({ text }: CreditFooterProps) {
  if (!text) return null;
  return (
    <div className="pointer-events-none fixed bottom-2 left-3 z-50 select-none rounded-md bg-slate-900/70 px-2.5 py-1 text-xs text-slate-100 shadow-sm backdrop-blur">
      {text}
    </div>
  );
}
